export const DEFAULT_LANGUAGE = 'en';

// Display languages accepted by the backend language validator.
export const LANGUAGE_OPTIONS = [
  { code: 'en', label: 'English' },
  { code: 'bg', label: 'Bulgarian' },
  { code: 'bs', label: 'Bosnian' },
  { code: 'hr', label: 'Croatian' },
  { code: 'cs', label: 'Czech' },
  { code: 'da', label: 'Danish' },
  { code: 'nl', label: 'Dutch' },
  { code: 'et', label: 'Estonian' },
  { code: 'fr', label: 'French' },
  { code: 'de', label: 'German' },
  { code: 'hu', label: 'Hungarian' },
  { code: 'is', label: 'Icelandic' },
  { code: 'it', label: 'Italian' },
  { code: 'lv', label: 'Latvian' },
  { code: 'lt', label: 'Lithuanian' },
  { code: 'pl', label: 'Polish' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'sk', label: 'Slovak' },
  { code: 'sl', label: 'Slovenian' },
  { code: 'es', label: 'Spanish' },
  { code: 'sv', label: 'Swedish' },
  { code: 'tr', label: 'Turkish' },
] as const;

export type DisplayLanguage = (typeof LANGUAGE_OPTIONS)[number]['code'];

export function normalizeDisplayLanguage(
  value?: string | null,
): DisplayLanguage {
  const code = value?.trim().toLowerCase();
  return (
    LANGUAGE_OPTIONS.find((option) => option.code === code)?.code ??
    DEFAULT_LANGUAGE
  );
}
